import React, { useState, useEffect, useRef } from 'react'
import { Link, NavLink,BrowserRouter,useHistory   } from 'react-router-dom';
//import { browserHistory } from 'react-router'
import config from '../../config';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import {token} from '../Actions/AuthAction';
import Loader from '../Common/Loader';
import ShowError from '../Common/Error';
import { setError } from '../../utils';
import ReactQuill from 'react-quill';
import { postInstitutionDriveApproval } from '../Actions/DriveAction';

const required = (value) => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          This field is required!
        </div>
      );
    }
  };
  const FormApproval = (props) => {
    console.log(props.driveid)
    
    const form = useRef();
    const checkBtn = useRef();
    //const [approvalList, setApprovalList] = useState({ value: '', error: '', options: [], isRequired: true });
    
    const approvalList = [
        
           {
                id:2,
                name:'Approved'
            },{
                id:3,
                name:'Rejected',
            }

        
        ];
    const [approval, setApproval] = useState({ value: '', error: '', options: [], isRequired: true });
    
    const [datamessage, setDatamessage] =  useState(null);
  
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(undefined);
    const [error, setError] = useState(undefined);
    const [setpasserror, setPassError] = useState(false);
    const [message, setMessage] = useState("");
    const [refresh, setRefresh] = useState(true);
  
    const pagepath = "/drivedetail/"+props.driveid;
    const redirectpath = "/drivedetail/"+props.driveid;


   
    let history = useHistory();

    useEffect(() => {
        
        

            
    
            
    
    }, [])

   

    const handleSubmit = (e) => {
        e.preventDefault();
        //localStorage.setItem("test", 'dfasdf');
        //alert(password);return false;
        setMessage("");
        setLoading(true);
    
        form.current.validateAll();
        if (checkBtn.current.context._errors.length === 0) {
    

    
        postInstitutionDriveApproval({ "key":token(),"driveid":props.driveid,"message":datamessage,"status":approval.value})
        .then(res => {
       props.getmsg()

                 //alert(res);
                 if(res.status){
                    
                    setError(res.message);
                    setPassError(true);
                    setLoading(false);
                    setStatus(res.status)
                    
                    //history.push("/universityadd");
                     //window.location.reload();
                  }else{
                    setError(res.message);
                    setPassError(false);
                    setLoading(false);
                    return false;
                  }
                 
          })

        } else {
            setLoading(false);
        }
        
      };


      
      const onHideModal=()=>{
        setError(undefined)
    }
    return (
        <>
      


      {loading && <Loader/>}
 
 {error &&<ShowError
            datastatus={status}
            datapagepath={pagepath}
            dataredirectpath={redirectpath}
            message={error}
            passerror={setpasserror}
            toggleModal={onHideModal}
            datarefresh={refresh}
           />}
                    <div className="card formcard mb-3">
                    <h4 className="table_heading position-relative">APPROVAL STATUS</h4>
                    
                        <div className="card-body">
                        <Form className="auth_form" ref={form}>
                                <div className="row">
                                    
                                 

                                    

                                   


                                    <div className="form-group col-md-12">
                                        <label className="small mb-1" for="inputPassword">Approval</label>
                                        <Select 
                                        validations={[required]}
                                                class="form-control rounded-pill" 
                                                title="Select State"
                                                onChange={e => setApproval({ ...approval, value: e.target.value })} value={approval.value}>
                                                <option selected>Choose Approval</option>
                                                {approvalList!==undefined&&approvalList.map(item => <option value={item.id}>{item.name}</option>)}
                                                
                                            </Select>
                                    </div>

                                    <div className="form-group col-md-12">
                                <label className="small mb-1" for="inputPassword">Comment</label>
                                <ReactQuill theme="snow" value={datamessage} onChange={(e) => setDatamessage(e)} />
                                
                            </div>
                                    
                                    
                                    <div className="form-group mt-4 mb-0">
                                        <button onClick={handleSubmit} className="btn btn-primary-custom mx-2">
                                            Submit
                                            </button>
                                            {loading && (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            )}
                                            {message && (
                                                <div className="form-group">
                                                <div className="alert alert-danger" role="alert">
                                                    {message}
                                                </div>
                                                </div>
                                            )}
                                            <CheckButton style={{ display: "none" }} ref={checkBtn} />
                                        <a className="btn btn-secondary-custom mx-2" href="#">Cancel</a>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
        </>
    )
}

export default FormApproval
